import { EventInput } from '@fullcalendar/core';
import { CalendarEventModel } from '../../../../../../api-service/clients';
import { ServiceProviderUrlBuilder } from '../../../utils/service-provider-url-builder';
import { createBaseCalendarEventInput, parseEventDate } from './helpers';

export function mapAssignmentFollowUpCalendarEvent(
  event: CalendarEventModel,
  citizenId: string,
  currentSpuId?: string
): EventInput | null {
  if (!event.entityId) {
    return null;
  }

  const startDate = parseEventDate(event.startDate);
  if (!startDate) {
    return null;
  }

  return {
    ...createBaseCalendarEventInput(event),
    start: startDate,
    allDay: true,
    display: currentSpuId === event.serviceProviderUnitId ? 'auto' : 'none',
    url: ServiceProviderUrlBuilder.buildCustomUrl(
      `view-assignment/${event.entityId}`,
      {
        citizenId,
        spuId: event.serviceProviderUnitId,
      }
    ),
  };
}
